export default __webpack_public_path__ + "static/3_1-498592968e0953c87fd2cd68d036e448.jpg";